import { render, staticRenderFns } from "./RFIDView.vue?vue&type=template&id=723e1f97&"
import script from "./RFIDView.vue?vue&type=script&lang=js&"
export * from "./RFIDView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports